var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsFilledUsers24Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "User Management") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Filled/users_24px"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "\\uD83C\\uDF08-Icon-Color"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "users",
    transform: "translate(0.000000, -0.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.4,4.8 C3.2825,4.8 4,4.0825 4,3.2 C4,2.3175 3.2825,1.6 2.4,1.6 C1.5175,1.6 0.8,2.3175 0.8,3.2 C0.8,4.0825 1.5175,4.8 2.4,4.8 Z M13.6,4.8 C14.4825,4.8 15.2,4.0825 15.2,3.2 C15.2,2.3175 14.4825,1.6 13.6,1.6 C12.7175,1.6 12,2.3175 12,3.2 C12,4.0825 12.7175,4.8 13.6,4.8 Z M14.4,5.6 L12.8,5.6 C12.36,5.6 11.9625,5.7775 11.6725,6.065 C12.68,6.6175 13.395,7.615 13.55,8.8 L15.2,8.8 C15.6425,8.8 16,8.4425 16,8 L16,7.2 C16,6.3175 15.2825,5.6 14.4,5.6 Z M8,5.6 C9.5475,5.6 10.8,4.3475 10.8,2.8 C10.8,1.2525 9.5475,0 8,0 C6.4525,0 5.2,1.2525 5.2,2.8 C5.2,4.3475 6.4525,5.6 8,5.6 Z M9.92,6.4 L9.7125,6.4 C9.1925,6.65 8.615,6.8 8,6.8 C7.385,6.8 6.81,6.65 6.2875,6.4 L6.08,6.4 C4.49,6.4 3.2,7.69 3.2,9.28 L3.2,10 C3.2,10.6625 3.7375,11.2 4.4,11.2 L11.6,11.2 C12.2625,11.2 12.8,10.6625 12.8,10 L12.8,9.28 C12.8,7.69 11.51,6.4 9.92,6.4 Z M4.3275,6.065 C4.0375,5.7775 3.64,5.6 3.2,5.6 L1.6,5.6 C0.7175,5.6 0,6.3175 0,7.2 L0,8 C0,8.4425 0.3575,8.8 0.8,8.8 L2.4475,8.8 C2.605,7.615 3.32,6.6175 4.3275,6.065 Z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsFilledUsers24Px);
export default __webpack_public_path__ + "static/media/Icons_Filled_users_24px.727a9da4.svg";
export { ForwardRef as ReactComponent };